<template>
 <div>
    <div class="detailsTitle">
      <h4>账户设置</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
       <div class="searchBtnBox">
          <el-form-item >
            <el-button type="primary" @click="addAccount">新建</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
       <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
     <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" btnCode="00IP002B004" v-if="scope.row.isDefault==2&&scope.row.accountStatus==1"   @click="tongguoFn(scope.row)">通过</el-button>
              <el-button type="text" size="mini" btnCode="00IP002B005"  v-if="scope.row.isDefault==2&&scope.row.accountStatus==1"   @click="bohuiFn(scope.row)">驳回</el-button>
              <el-button type="text" size="mini" btnCode="00IP002B005" v-if="scope.row.accountStatus==2"  @click="delFn(scope.row)">删除</el-button>
              <el-button type="text" size="mini" btnCode="00IP002B005" v-if="scope.row.isDefault==2&&scope.row.accountStatus>2"  @click="SWMRfn(scope.row)">设为默认</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="auditStatus" label="账户状态" width="100">
          <template scope="scope">
            {{[ "已启用", "未启用" ][scope.row.isDefault-1]}}
          </template>
        </el-table-column>
        <el-table-column property="auditStatus" label="账户类型" width="100">
          <template scope="scope">
            {{[ "线上业务", "线下业务" ][scope.row.accountClassify-1]}}
          </template>
        </el-table-column>
         <el-table-column property="accountStatus" label="审核状态" width="100">
          <template scope="scope">
            {{[ "未开通","审核中", "审核驳回", "审核通过", "审核通过", "审核通过" ][scope.row.accountStatus]}}
          </template>
        </el-table-column>
        <el-table-column property="vtlCustNm" width="240"  :formatter="emptyFn"   label="资金分簿名称"></el-table-column>
        <el-table-column property="zxAccNo"  width="170"  :formatter="emptyFn"   label="资金分簿号"></el-table-column>
        <el-table-column property="legalPersonNm"  width="100"  :formatter="emptyFn"   label="法人名称"></el-table-column>
        <el-table-column property="custCertNo"  width="200"  :formatter="emptyFn"   label="法人身份证号"></el-table-column>
        <el-table-column property="contactName"  width="100"  :formatter="emptyFn"   label="联系人"></el-table-column>
        <el-table-column property="contactPhone"  width="150"  :formatter="emptyFn"   label="联系电话"></el-table-column>
        <el-table-column property="commAddress"  width="240"  :formatter="emptyFn" label="通讯地址" ></el-table-column>
        <el-table-column property="createUserName"  width="100"  :formatter="emptyFn"   label="创建人"></el-table-column>
        <el-table-column property="createTime"  width="170"  :formatter="dateTimeFormat"   label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 新建 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" @close="closeDialog"  width="450px" center>
      <span>
        <el-form :inline="true" :model="addFrom" ref="addFrom"  :rules="rules"  class="demo-form-inline yanzheng jiaoyan" label-width="120px" size="mini">
        <div class="inpBox">
           <el-form-item label="账户类型:" prop="accountClassify" class="ziti" >
              <el-radio-group v-model="addFrom.accountClassify" >
                <el-radio :label="1">线上业务</el-radio>
                <el-radio :label="2">线下业务</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item label="资金分簿名称:" prop="vtlCustNm">
            <el-input  placeholder="" v-model="addFrom.vtlCustNm" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="法人名称:" prop="legalPersonNm">
            <el-input  placeholder="" v-model="addFrom.legalPersonNm" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证号:" prop="custCertNo">
            <el-input  placeholder="" v-model="addFrom.custCertNo" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="通讯地址:" prop="commAddress">
            <el-input  placeholder="" v-model="addFrom.commAddress"  maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="联系人:" prop="contactName">
            <el-input  placeholder="" maxlength="18" v-model="addFrom.contactName"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="contactPhone">
            <el-input  placeholder="" v-model="addFrom.contactPhone" maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="验证码:" prop="validCode" >
          <el-input  placeholder="" v-model="addFrom.validCode" maxlength="6"></el-input>
          <div style="position: absolute;right: 4px;top: 0;">
             <span class="codeBtn" v-if="isShowGetCode" @click="getIdentifyCode">获取验证码</span>
            <span v-else class="codeBtn cancel-pointer">{{ countdown }}s后可重试</span>
          </div>
          </el-form-item>

        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { emptyFn, dateTimeFormat } from '@/utils/util'
import {
  platformAcclist, // 列表
  platformAccountAdd, auditAcc, updatePlatformAccDefault, delPlatformAcc
} from '@/api/consignment'
export default {
  data () {
    let id = this.$route.query.id
    let type = this.$route.query.type
    return {
      id: id,
      type: type,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      title: '新建',
      dialogVisible: false,
      smsCode: '', // 判断输入的是否正确
      countdown: 60,
      isShowGetCode: true,
      addFrom: {
      },
      // 查询
      searchFrom: {

      },
      rules: {
        accountClassify: [
          { required: true, message: '请选择账户类型', trigger: 'blur' }
        ],
        vtlCustNm: [
          { required: true, message: '请输入资金分簿名称', trigger: 'blur' }
        ],
        legalPersonNm: [
          { required: true, message: '请输入法人名称', trigger: 'blur' }
        ],
        custCertNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        commAddress: [
          { required: true, message: '请输入通信地址', trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        validCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          this.rule.mobile
        ]

      },
      tableList: [],
      loading: 'false',
      isDisable: false

    }
  },
  created () {
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 132) + 'px'
  },
  methods: {
    // 设为默认
    SWMRfn (row) {
      this.$confirm('是否执行设为默认操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        let formData = new FormData()
        formData.append('id', row.id)
        updatePlatformAccDefault(formData).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 通过
    tongguoFn (row) {
      this.$confirm('是否执行设为默认操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        auditAcc({ id: row.id, accountStatus: 1 }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 驳回
    bohuiFn (row) {
      this.$confirm('是否执行驳回操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        auditAcc({ id: row.id, accountStatus: 2 }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 验证手机
    validateMobile (mobile) {
      return /1(3|4|5|6|7|8|9)\d{9}/.test(mobile)
    },
    // 点击获取验证码
    getIdentifyCode () {
      this.$set(this.addFrom, 'validCode', '')
      if (this.addFrom.contactPhone && this.validateMobile(this.addFrom.contactPhone)) {
        this.$axios({
          method: 'post',
          url: this.global.driverNameT + '/api/sendSmsCode',
          data: {
            account: this.addFrom.contactPhone
          }
        }).then(res => {
          this.countDown()
          this.isShowGetCode = false
        }).catch(error => {
          this.$message.error(error.message)
        })
      } else {
        this.$message.error('请输入正确手机号')
      }
    },
    countDown () {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      platformAcclist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },

    // 新建
    addAccount () {
      this.title = '新建'
      this.dialogVisible = true
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          platformAccountAdd(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        let formData = new FormData()
        formData.append('id', row.id)
        delPlatformAcc(formData).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = {}
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        transTimes: null,
        accountId: this.id,
        extertransTypes: [1, 2, 3, 4, 5]
      }
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox /deep/.el-input__inner{
  width: 200px!important;
}
.codeBtn{

  color: #409EFF;
  cursor: pointer;
}
/deep/.el-form-item__content{
  position: relative;
}
</style>
